<template>
  <div role="button" class="card px-2 py-4 shadow--sm" @click="$emit('onItemSelected', item)">
    <div class="container">
      <div class="row d-flex align-items-center">
        <div class="col--10">
          <b class="text-lg">
            {{ label }}
          </b>
        </div>
        <div class="col--2 d-flex justify-content-end">
          <smtt-icon icon="angle-righ-double" color="#4F23C9"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Level",
  props: {
    label: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
}
</script>

<style scoped>

</style>